import { useMembershipSuspense } from '../api/get-membership';
import { FlyoutRow, FlyoutSection } from '@/shared/components/flyout';
import { MembershipRoleBadges } from './membership-role-badges';
import { MembershipStatusBadge } from './membership-status-badge';
import { formatMobileNumber } from '@/utils/shared/formatters';
import { User } from 'lucide-react';

export function MembershipPanel({ userId, groupId }: { userId: string; groupId: string }) {
  const { data: membership } = useMembershipSuspense({ userId, groupId, params: { include: ['user'] } });

  return (
    <>
      <div className="text-gray-800 dark:text-gray-100 font-semibold text-center mb-1">Gruppmedlem</div>
      <div className="max-w-sm mx-auto lg:max-w-none flex flex-col gap-6">
        <FlyoutSection className="mt-16 text-center">
          <div className="size-24 inline-flex p-4 bg-white border-ring rounded-full -mt-16">
            <User className="text-primary size-16" />
          </div>
          <h3 className="text-base font-medium text-gray-800 dark:text-gray-100 mb-3">{membership.user!.name}</h3>

          <FlyoutRow label="Roll">
            <MembershipRoleBadges roles={membership.roles} />
          </FlyoutRow>
          <FlyoutRow label="Status">
            <MembershipStatusBadge status={membership.status} />
          </FlyoutRow>
        </FlyoutSection>

        <FlyoutSection label="Kontaktuppgifter">
          <FlyoutRow label="E-post">{membership.user!.email}</FlyoutRow>
          <FlyoutRow label="Mobil">{formatMobileNumber(membership.user!.mobileNumber)}</FlyoutRow>
        </FlyoutSection>
      </div>
    </>
  );
}
